import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addFeatureFlagIconLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.icon.add-feature-flag-icon-label',
		defaultMessage: 'Add feature flag icon',
		description: 'Label for icon that signals a button used to connect or add feature flags.',
	},
});
